/**
 * Модалка удаления товара спецификации (#deleteProductModal).
 *
 * Модалка добавления товара — через глобальный window.ProductSelectionModal
 * (см. resources/js/features/product-modal/). Legacy FancyBox-flow для #modal-add-product
 * удалён — элемент #modal-add-product в Blade-шаблонах больше не рендерится.
 *
 * Массовое удаление — через кнопку #bulk-delete-btn.
 */

import { apiRequest } from '../../api.js';
import { state } from './store.js';
import { loadSpecTable } from './table.js';

// ─── Delete product modal ─────────────────────────────────────────────────
export function openDeleteProductModal(productId) {
    if (productId) state.deleteProductId = productId;
    const modal = document.getElementById('deleteProductModal');
    if (modal) modal.style.display = 'flex';
}

export function closeDeleteProductModal() {
    const modal = document.getElementById('deleteProductModal');
    if (modal) modal.style.display = 'none';
    state.deleteProductId = null;

    const confirmBtn = document.getElementById('confirm-delete-btn');
    if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.textContent = confirmBtn.dataset.originalText || 'Delete';
    }
}

async function deleteProduct(productId) {
    try {
        await apiRequest(`/removeprojectspec/${productId}`, { method: 'DELETE' });
        loadSpecTable();
    } catch (e) {
        window.showToast('error', TOAST_MESSAGES.PRODUCT.ERROR_DELETING);
    }
}

async function bulkDelete() {
    if (state.selectedProducts.length === 0) return;

    try {
        const data = await apiRequest(`/project/${state.projectId}/spec/bulk-delete`, {
            method: 'DELETE',
            body: { product_ids: state.selectedProducts },
        });
        if (data && data.success) {
            state.selectedProducts = [];
            loadSpecTable();
        }
    } catch (e) {
        console.error('Error bulk deleting:', e);
    }
}

export function initModalHandlers() {
    // Delegated handlers — не ловим через .on/.off (у нас нет переинициализации)
    document.addEventListener('click', e => {
        // Подтверждение удаления
        if (e.target.closest('#confirm-delete-btn')) {
            if (state.deleteProductId) {
                deleteProduct(state.deleteProductId);
                closeDeleteProductModal();
            }
            return;
        }

        // Клик по overlay — закрыть модалку
        const modal = document.getElementById('deleteProductModal');
        if (modal && e.target === modal) {
            closeDeleteProductModal();
        }
    });

    // Массовое удаление
    const bulkDeleteBtn = document.getElementById('bulk-delete-btn');
    if (bulkDeleteBtn) bulkDeleteBtn.addEventListener('click', bulkDelete);
}
